import { useActivatedIntegration } from '../../../use-activated-integration';
import { INTEGRATION_PROVIDERS } from '@vy/types';

export function useXeroEnabled() {
  return useActivatedIntegration(INTEGRATION_PROVIDERS.xero, {
    suspense: true,
  });
}
